import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../swof/api";
import { AdminShell } from "./ProtectedRoute";

const knopStijl = {
  fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase",
  color: "var(--gold)", border: "1px solid rgba(201,169,97,0.4)", padding: "10px 16px",
  background: "transparent",
};

const SOORT = { alles: "Hele site", blok: "Eén blok", terugzetten: "Teruggezet" };

export default function PublicatiesPage() {
  const [lijst, setLijst] = useState(null);
  const [fout, setFout] = useState("");
  const [bezig, setBezig] = useState(false);

  const laad = () => api.get("/admin/publicaties").then(({ data }) => setLijst(data));

  useEffect(() => {
    document.body.classList.add("swof");
    laad();
    return () => document.body.classList.remove("swof");
  }, []);

  const terugzetten = async (p) => {
    const wanneer = new Date(p.gepubliceerd_op).toLocaleString("nl-NL");
    if (!window.confirm(`De publicatie van ${wanneer} weer live zetten?\n\nDe bezoeker ziet dan die versie. Uw concept blijft zoals het is.`)) return;
    setBezig(true);
    setFout("");
    try {
      await api.post(`/admin/publicaties/${p.id}/terugzetten`);
      await laad();
    } catch (e) {
      setFout(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBezig(false);
    }
  };

  return (
    <AdminShell title="Publicaties">
      <h1 style={{
        fontFamily: "var(--serif)", fontSize: "clamp(30px, 3.6vw, 46px)", fontWeight: 400,
        margin: "0 0 12px", letterSpacing: "-0.02em",
      }}>Wat er live is gezet</h1>
      <p style={{ fontFamily: "var(--sans)", fontSize: 14, opacity: 0.65, margin: "0 0 36px", maxWidth: "64ch" }}>
        Elke publicatie is een momentopname van de site. De bovenste staat nu live. De laatste
        dertig worden bewaard; u kunt er één weer live zetten zonder uw concept kwijt te raken.
      </p>

      {fout && (
        <div data-testid="publicaties-fout" style={{
          marginBottom: 24, padding: "12px 14px", border: "1px solid rgba(201,80,60,0.5)",
          background: "rgba(201,80,60,0.08)", fontFamily: "var(--sans)", fontSize: 13, color: "#e8b0a4",
        }}>{fout}</div>
      )}

      {!lijst ? (
        <div data-testid="publicaties-laden" style={{ opacity: 0.5 }}>Laden…</div>
      ) : lijst.length === 0 ? (
        <div data-testid="publicaties-leeg" style={{
          border: "1px solid var(--line)", padding: "22px 24px", fontFamily: "var(--sans)", fontSize: 14,
        }}>
          Er is nog niets gepubliceerd. Tot de eerste publicatie toont de site het concept.
        </div>
      ) : (
        <ul data-testid="publicatie-lijst" style={{
          listStyle: "none", padding: 0, margin: 0, borderTop: "1px solid var(--line)",
        }}>
          {lijst.map((p, i) => (
            <li key={p.id} data-testid={`publicatie-${p.id}`} style={{
              display: "grid", gridTemplateColumns: "120px 190px 1fr 190px 150px", gap: 16,
              alignItems: "center", padding: "16px 8px", borderBottom: "1px solid var(--line)",
            }}>
              <span className="eyebrow" style={{
                fontSize: 9, color: i === 0 ? "var(--gold)" : "rgba(243,234,215,0.5)",
              }}>{i === 0 ? "Nu live" : SOORT[p.soort] || p.soort}</span>
              <span style={{ fontFamily: "var(--mono)", fontSize: 11 }}>
                {new Date(p.gepubliceerd_op).toLocaleString("nl-NL")}
              </span>
              <span style={{ fontFamily: "var(--serif)", fontSize: 17 }}>{p.omschrijving}</span>
              <span style={{ fontFamily: "var(--sans)", fontSize: 12, opacity: 0.6 }}>{p.door_naam}</span>
              {i === 0 ? <span /> : (
                <button onClick={() => terugzetten(p)} disabled={bezig}
                  data-testid={`publicatie-terug-${p.id}`} style={knopStijl}>Weer live zetten</button>
              )}
            </li>
          ))}
        </ul>
      )}
    </AdminShell>
  );
}
